import { useState } from "react";
import { MapPin, Plus, Edit } from "lucide-react";
import { Button } from "../../ui/button";
import { DeliveryAddressBottomSheet } from "./DeliveryAddressBottomSheet";
import { DeliveryAddress } from "@nusrif/types";
interface DeliveryAddressSectionProps {
  currentAddress?: DeliveryAddress;
  onAddressChange: (address: DeliveryAddress) => void;
}
export const DeliveryAddressSection = ({
  currentAddress,
  onAddressChange,
}: DeliveryAddressSectionProps) => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const handleAddAddress = () => {
    setIsBottomSheetOpen(true);
  };
  const handleEditAddress = () => {
    setIsBottomSheetOpen(true);
  };
  const handleSaveAddress = (address: DeliveryAddress) => {
    onAddressChange(address);
    setIsBottomSheetOpen(false);
  };
  const formatAddress = (address: DeliveryAddress): string => {
    const parts = [
      address.addressLine1,
      address.addressLine2,
      address.city,
      address.state,
      address.pincode,
    ].filter(Boolean);
    return parts.join(", ");
  };
  const getAddressTypeLabel = (type: string): string => {
    switch (type) {
      case "home":
        return "Home";
      case "office":
        return "Office";
      default:
        return "Other";
    }
  };
  return (
    <>
      <div className="space-y-4 p-4 bg-white rounded-lg border border-gray-100 shadow-sm">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-black flex items-center gap-2">
            <MapPin className="w-5 h-5 text-gray-600" />
            Delivery Address
          </h3>

          {currentAddress && (
            <Button
              variant="ghost"
              size="sm"
              className="text-primary-blue hover:bg-blue-50"
              onClick={handleEditAddress}
            >
              <Edit className="w-4 h-4 mr-1" />
              Edit
            </Button>
          )}
        </div>
        {currentAddress ? (
          <div className="space-y-3">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-medium text-black">
                    {currentAddress.name}
                  </span>
                  {currentAddress.type && (
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
                      {getAddressTypeLabel(currentAddress.type)}
                    </span>
                  )}
                </div>
                <p className="text-sm text-gray-600 mb-1">
                  {currentAddress.phone}
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {formatAddress(currentAddress)}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-6">
            <MapPin className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-gray-600 mb-4">No delivery address added</p>
            <Button
              onClick={handleAddAddress}
              className="px-6 py-2 rounded-full font-medium flex items-center gap-2 mx-auto"
            >
              <Plus className="w-4 h-4" />
              Add Address
            </Button>
          </div>
        )}
        {currentAddress && (
          <Button
            onClick={handleAddAddress}
            variant="outline"
            className="w-full h-12 border-dashed border-gray-300 text-gray-600 hover:border-gray-400 hover:text-gray-700 flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Add New Address
          </Button>
        )}
      </div>
      <DeliveryAddressBottomSheet
        isOpen={isBottomSheetOpen}
        onClose={() => setIsBottomSheetOpen(false)}
        onSave={handleSaveAddress}
        existingAddress={currentAddress}
      />
    </>
  );
};
